module.exports = __webpack_public_path__ + "static/media/house_of_cards_cover.7171bca2.jpg";